import { render } from "./TheRole.vue?vue&type=template&id=0ff11aa4"
import script from "./TheRole.vue?vue&type=script&lang=js"
export * from "./TheRole.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__